import { Breakpoint } from '@/enums'
import { themeBreakpointDown, toThemePixels } from '@/utils'
import styled from 'styled-components'
import { Column } from '../../styled'

export const EmojiContainer = styled.div`
  font-size: ${toThemePixels(20)};
  margin-bottom: ${toThemePixels(6)};
`

export const ContentWrapper = styled(Column)`
  margin: auto;
  width: 100%;
  max-width: 500px;
  gap: ${toThemePixels(10)};
  align-items: center;
  justify-content: center;

  ${themeBreakpointDown(Breakpoint.sm)} {
    width: 90%;
  }
`

export const Content = styled(Column)`
  gap: ${toThemePixels(4)};
  text-align: center;
  width: 100%;
  align-items: center;
  justify-content: center;
  word-break: break-word;
`
